import { Directive, ElementRef, HostListener, Input } from '@angular/core';

/// Директива для ограничения длинны
/// usage on input: req-length = "5"
@Directive({
  selector: '[req-length]'
})

export class RequiredLength {
  @Input('req-length') rlength: number;
  constructor(private el: ElementRef) { }

  @HostListener('keydown', ['$event']) onKeyDown(event) {
    let currentLength = this.el.nativeElement.value.length; 
    let e = (event as KeyboardEvent);

    if(e.keyCode == 8)
      return

    if(currentLength + 1 > this.rlength)
        e.preventDefault()
        
    else
      return
    
        
  }
}


// WEBPACK FOOTER //
// ./src/app/directives/length.directive.ts